import { z } from 'zod';
export const redirectSessionSchema = z.object({
    codeVerifier: z.string(),
    state: z.string(),
    pathBeforeRedirect: z.string(),
});
